import { render, staticRenderFns } from "./ArchiveRecipes.vue?vue&type=template&id=c6e02d50&scoped=true"
import script from "./ArchiveRecipes.vue?vue&type=script&lang=js"
export * from "./ArchiveRecipes.vue?vue&type=script&lang=js"
import style0 from "./ArchiveRecipes.vue?vue&type=style&index=0&id=c6e02d50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e02d50",
  null
  
)

export default component.exports